import React, { useEffect, useState } from 'react';
import { ChevronLeftOutlined, ChevronRightOutlined } from '@mui/icons-material';
import { useKeyPressed } from '@/hooks/keyboard';
import styles from './Photos.module.scss';

const View: React.FC<{ photos: string[]; index: number }> = ({ photos, index }) => {
  const [current, setCurrent] = useState(index);
  const photo = photos[current];

  const arrowLeft = useKeyPressed('ArrowLeft');
  const arrowRight = useKeyPressed('ArrowRight');

  const onClickLeft = () => {
    setCurrent(current - 1 < 0 ? 0 : current - 1);
  };

  const onClickRight = () => {
    setCurrent(current + 1 === photos.length ? photos.length - 1 : current + 1);
  };

  useEffect(() => {
    if (arrowLeft) onClickLeft();
  }, [arrowLeft]);
  useEffect(() => {
    if (arrowRight) onClickRight();
  }, [arrowRight]);

  return (
    <div className={styles.container}>
      <div className={styles.photoContainer}>
        {photo && (
          <div
            className={styles.photo}
            style={{ backgroundImage: `url("${photo}")` }}
          />
        )}
      </div>
      <div
        className={styles.leftButton}
        onClick={onClickLeft}
      >
        <div className={styles.buttonWrapper}>
          <ChevronLeftOutlined
            fontSize={'large'}
            className={styles.button}
          />
        </div>
      </div>
      <div
        className={styles.rightButton}
        onClick={onClickRight}
      >
        <div className={styles.buttonWrapper}>
          <ChevronRightOutlined
            fontSize={'large'}
            className={styles.button}
          />
        </div>
      </div>
      <div className={styles.indexContainer}>
        {current + 1} / {photos.length}
      </div>
    </div>
  );
};

export default View;
